import { Typography } from '@mui/material';
import { FormInput } from '@/components/FormInput';
import { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { AdFormProps } from '../config';
import { Control, FieldErrors } from 'react-hook-form';
import { Info } from '@/commons/info';
import { CreateAdFormData } from '@/pages/ad-pages/CreateAd';

type Props = {
  control: Control<CreateAdFormData>;
  errors: FieldErrors<CreateAdFormData>;
  fields?: AdFormProps[];
};

export const QrCodeForm: FC<Props> = ({ control, errors }) => {
  const { t } = useTranslation();

  return (
    <div className="w-full mb-5">
      <Typography variant="h6" sx={{ mb: '14px' }}>
        <Trans i18nKey="qr_code_form.title" />
      </Typography>
      <div className="w-full">
        <div className="flex gap-3">
          <div className="flex flex-col gap-3 basis-3/4">
            <FormInput
              name="qrUrl"
              label={t('create_ad.qr_value')}
              control={control}
              error={!!errors['qrUrl']}
              fullWidth={true}
              helperText={errors['qrUrl'] && errors['qrUrl'].message}
            />
            <FormInput
              name="qrText"
              label={t('create_ad.qr_cta')}
              control={control}
              error={!!errors['qrText']}
              fullWidth={true}
              helperText={errors['qrText'] && errors['qrText'].message}
              minRows={3}
              multiline={true}
            />
          </div>
          <div className="basis-1/4">
            <Info>
              <div className="pb-1">{t('qr_code_form.info')}</div>
            </Info>
          </div>
        </div>
      </div>
    </div>
  );
};
